import React from 'react';
import styled from 'styled-components';

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;

  img {
    height: ${props => props.size || '32px'};
    width: auto;
  }
`;

const Logo = ({ 
  reversed = false, 
  iconOnly = false,
  size,
  className 
}) => {
  const logoSrc = iconOnly 
    ? `/assets/${reversed ? 'icon-reversed.svg' : 'icon.svg'}`
    : `/assets/${reversed ? 'logo-reverse.svg' : 'logo.svg'}`;

  return (
    <LogoWrapper size={size} className={className}>
      <img src={logoSrc} alt="Moogul" />
    </LogoWrapper>
  );
};

export default Logo; 